"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericEditForm = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const Loading_1 = require("../../components/Loading/Loading");
const GenericForm_1 = require("./GenericForm");
exports.GenericEditForm = (props) => {
    const { dataSelector, loadingSelector, paramKey = 'id', recordId, onSubmit, onSubmitOptions, onBack, onFetch, onDelete, validationSchema, EmbedForm, initialValues, tNamespace, requestParams, colClassName, rowClassName, } = props;
    const dispatch = react_redux_1.useDispatch();
    const params = react_router_1.useParams();
    const [isFetched, setIsFetched] = react_1.useState(false);
    const data = react_redux_1.useSelector(dataSelector);
    const getId = react_1.useCallback(() => {
        return recordId || params[paramKey];
    }, [recordId, params, paramKey]);
    react_1.useEffect(() => {
        dispatch(onFetch(getId(), requestParams));
        setIsFetched(true);
    }, [onFetch, dispatch, setIsFetched, getId, requestParams]);
    if (!isFetched)
        return react_1.default.createElement(Loading_1.Loading, { centeredVertical: true });
    return (react_1.default.createElement(GenericForm_1.GenericForm, { initialValues: Object.assign(Object.assign({}, initialValues), data), loadingSelector: loadingSelector, onBack: onBack, EmbedForm: EmbedForm, rowClassName: rowClassName, colClassName: colClassName, onSubmit: onSubmit, onSubmitOptions: onSubmitOptions, onDelete: onDelete, recordId: getId(), validationSchema: validationSchema, tNamespace: tNamespace }));
};
//# sourceMappingURL=GenericEditForm.js.map